import {setCookie, getCookie} from "./cookie";

document.addEventListener('DOMContentLoaded', () => {
    const cookieNotification = document.querySelector('.cookie-notification');

    if (!cookieNotification) return;

    const noAgreeBtn = cookieNotification.querySelector('[data-noagree]');
    const agreeBtn = cookieNotification.querySelector('[data-agree]');

    // Если нет cookies, то показываем плашку
    if (!getCookie('_site-agreement')) {
        cookieNotification.classList.remove('cookie-notification--hide');
    }

    // Нажатие кнопки согласия
    agreeBtn.addEventListener('click', () => {
        setCookie('_site-agreement', 'y', '/');
        cookieNotification.classList.add('cookie-notification--hide');
    });

    // Нажатие кнопки отказа
    noAgreeBtn.addEventListener('click', () => {
        setCookie('_site-agreement', 'y', '/');
        cookieNotification.classList.add('cookie-notification--hide');
    });
});
